
import { Swiper, Navigation } from "swiper";
import HotArticleCard from './HotArticleCard.vue';

export default {
    name: "article-hot-container",
    components: {
        HotArticleCard,
    },
    props: {
        article_data: Array,
        article_data_full: Array,
        pa_page_name: String
    },
    data() {
        return {
            pa_count: 1,
            swiper: '',
        }
    },
    computed: {
        article_model_id_index() {
            return this.$store.state.article.model_id_index;
        },
    },
    mounted() {
        Swiper.use([Navigation]);
        this.swiper = new Swiper(".hot_swiper", {
            direction: "horizontal",
            slidesPerView: 1.4,
            slidesPerGroup: 1,
            spaceBetween: 8,
            observer: true,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
    }
}
